import React, { useEffect, useState } from "react";
import useApi from "src/configs/api";
import { UserDetails, UserFormRequest } from "./models";
import { CurrencyDto } from "src/models";
import { DialogContent, DialogHeader, DialogTitle, DialogClose } from "src/components/ui/dialog";
import { useAlert } from "src/hooks/use-alert";

export interface PreferencesDialogProps {
    data?: UserDetails.Preferences | null | undefined;
    onSubmit? : () => void;
    onClose : () => void;
}   

function classNames(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

const toPreferencesFormDto = (preferences? : UserDetails.Preferences | null) : UserFormRequest.Preferences => ({
    currency: preferences?.currency?.value?.toString() ?? "IDR"
})

export const PreferencesDialog = ({ data, onSubmit, onClose } : PreferencesDialogProps) => {
    const api = useApi();
    const [currencies, setCurrencies] = useState<CurrencyDto[]>([]);
    const [updatedData, setUpdatedData] = useState<Partial<UserFormRequest.Preferences>>( {} )
    const { showSuccess, showError} = useAlert()

    const [form, setForm] = useState<UserFormRequest.Preferences>(() => toPreferencesFormDto(data));
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        fetchFormReferences();
    }, [])

    useEffect(() => {
        setForm(toPreferencesFormDto(data));
        // setformValidations(null);
    }, [data]);

    const fetchFormReferences = async () => {
        try
        {
            const res = await api.get("/master-data/currency");
            if (res.status === 200) setCurrencies(res.data.data);
            else
                return null;
        }
        catch{}
    }

    
    const handleSubmit  = async (e : React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try
        {
            
            setIsProcessing(true);
            const response = await updatePreferences(form);

            if (!response.success) 
                showError(response.message);

            showSuccess("Preferences updated successfully.");
            await onSubmit?.();
            onClose();
        }
        catch{
            showError("Failed to update preferences. Please try again later.");
        }
        finally {
            setIsProcessing(false);
        }
    }

    const updatePreferences = async (data: UserFormRequest.Preferences) => {
        const response = await api.put("/user/me/preferences", data);
        return response.data;
    };

    const handleCurrencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => 
    {
        const {value} = e.target;
        setForm((prev) => ({
            ...prev,
            currency: value
        }))
    }

    return (

        <DialogContent showCloseButton={false} className="sm:max-w-md text-base">
            <DialogHeader >
                <DialogTitle className="text-large">Edit Preferences</DialogTitle>
            </DialogHeader>

            <form className="space-y-3" onSubmit={handleSubmit} method="POST">
                <div>
                    <label htmlFor="currency" className="block text-sm font-semibold leading-6 text-gray-900">
                        {`Currency`} 
                    </label>
                    <div className="mt-2">
                       <select
                            name='currency'
                            onChange={handleCurrencyChange}
                            value={form.currency ?? "IDR"}
                            required
                            className={classNames(
                                `block w-full rounded-md border-0 py-2 px-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 required:border-pink-500 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`                            )}
        >
                            {currencies.map(o => (
                                <option key={o.code} value={o?.code}>
                                    {o?.name} ({o?.code}) — {o?.symbol}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="grid md:grid-cols-3 gap-2 my-5">
                    <div className="md:col-span-2 md:order-last">
                        <button 
                            type='submit'
                            disabled={isProcessing}
                            className="block w-full rounded-md border-1 py-2.5 px-2.5 
                            bg-black text-white font-bold text-sm
                            text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
                        >
                            { isProcessing ? "Saving..." : "Save Changes" }
                        </button>
                    </div>
                    <div>
                        <DialogClose asChild>
                        <button 
                            type='button'
                            className="block w-full rounded-md border-1 py-2.5 px-2.5 
                            font-bold text-sm
                            text-red-500 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-red-500 hover:text-white  focus:ring-2 focus:ring-inset focus:ring-red-600 sm:leading-6"
                        >
                            Cancel
                        </button>
                        </DialogClose>
                    </div>
                </div>
            </form>
           
        </DialogContent>
    )

}